var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoInfo = function SvgIcoInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10m10.003-5a.97.97 0 0 0-.708.294.96.96 0 0 0-.295.709q0 .414.295.705a.97.97 0 0 0 .707.292q.412 0 .705-.292A.96.96 0 0 0 11 6.003a.97.97 0 0 0-.293-.709.96.96 0 0 0-.705-.294M9 10a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoInfo;